import React from "react";
import { Plan2PlateIconButton } from "./Plan2PlateIconButton";

export const AddButton = (props: { onClick: () => void }) => {
  return (
    <Plan2PlateIconButton
      aria-label={"add"}
      data-cy="add-button"
      title={"Hinzufügen"}
      icon={"plus"}
      onClick={props.onClick}
    />
  );
};
